import { SortDirection } from '@/libs/interfaces'

export const CONSTANTS = {
  DATE_FORMAT: 'yyyy-MM-dd',
  DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm',
  DEFAULT_QUERY_PARAMS: {
    limit: 10,
    sortDirection: SortDirection.ASC,
  },
  BIG_LIMIT: 100,
  DEBOUNCE_DELAY: 500,
  CURRENCY: 'SEK',
}
